import Service, { type Registry as Services, service } from '@ember/service';
import type PowerCalendarService from 'ember-power-calendar/services/power-calendar';
import type { UserLocale } from 'frontend-utils/models/user';
import type { SupportedLocale } from 'lumen/services/dates';

/**
 * A tiny service responsible for translating the Lighthouse concept of locale
 * to locales supported by ember-power-calendar.
 */
export default class LocaleService extends Service {
  @service declare dates: Services['dates'];
  @service declare powerCalendar: PowerCalendarService;

  setLocale(userLocale: UserLocale): void {
    let locale = userLocale as SupportedLocale;

    // en-us has to become en <-> en has to become en-gb
    if (userLocale === 'en') {
      locale = 'en-gb';
    }

    if (userLocale === 'en-us') {
      locale = 'en';
    }

    this.dates.setLocale(locale);
    this.powerCalendar.set('locale', locale);

    window.locale = locale;
  }
}

declare module '@ember/service' {
  interface Registry {
    locale: LocaleService;
  }
}
